import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeepDiveMultiRoutingModule } from './deep-dive-multi-routing.module';
import { DeepDiveMultiComponent } from './deep-dive-multi.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxChartModule, DxTextAreaModule, DxRangeSelectorModule, DxDataGridModule, DxPopupModule, DxDateBoxModule, DxSwitchModule, DxScrollViewModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { NextPreviousPopupModule } from 'src/app/widgets/next-previous-popup/next-previous-popup.module';
import { TopdownAdjustmentCommonModule } from 'src/app/widgets/topdown-adjustment-common/topdown-adjustment-common.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PaginationControlsComponent } from 'src/app/widgets/pagination-controls/pagination-controls.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NumberBoxComponent } from 'src/app/components/number-box/number-box/number-box.component';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';


@NgModule({
  declarations: [DeepDiveMultiComponent],
  imports: [
    CommonModule,
    NumberBoxComponent,
    DeepDiveMultiRoutingModule,
    DxChartModule,
    DxTextAreaModule, DxRangeSelectorModule,
    DxDataGridModule,
    DevEpressCommonModule,
    DxPopupModule, DxDateBoxModule, FormsModule, ReactiveFormsModule,
    TopdownAdjustmentCommonModule, InfiniteScrollModule, DxScrollViewModule,
    BookmarkModule, DxSwitchModule, NextPreviousPopupModule, NgxPaginationModule,
    PaginationControlsComponent, WebExportModule
  ]
})
export class DeepDiveMultiModule { }
